import { useEffect, useState, useRef } from "react";
import { useLocalization } from "@fluent/react";
import { LoadingSkeleton } from "@narmi/design_system";
import ApiHttp from "byzantine/src/ApiHttp";
import { useNotificationContext } from "cerulean";

import styles from "./CardHubSSO.module.scss";

export interface CardHubSSOResponse {
  action_url: string;
  base_url: string;
  sso_payload: string;
  fi_token: string;
  app_token: string;
  subscriber_reference_id: string;
  channel: string;
}

const redirectUrl = (ssoResponse: CardHubSSOResponse) => {
  const fiToken = `fiToken=${ssoResponse.fi_token}`;
  const appToken = `appToken=${ssoResponse.app_token}`;
  const subscriberReferenceId = `subscriberReferenceId=${ssoResponse.subscriber_reference_id}`;
  const channel = `channel=${ssoResponse.channel}`;
  return `${ssoResponse.base_url}/?${fiToken}&${appToken}&${subscriberReferenceId}&${channel}`;
}

const CardHubSSO = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const { sendNotification } = useNotificationContext();
  const { l10n } = useLocalization();
  const [isLoading, setIsLoading] = useState(true);
  const [ssoResponse, setSSOResponse] = useState<CardHubSSOResponse>();

  useEffect(() => {
    // 1) Get the SSO response from our backend
    const requestSSO = async () => {
      try {
        const response = await ApiHttp.fetch<CardHubSSOResponse>(
          "signed_urls/cards/card_hub/",
          { method: "GET" }
        );
        if (response == null) {
          return;
        }
        setSSOResponse(response);
      } catch (error) {
        sendNotification({
          type: "negative",
          text: l10n.getString("error-unknown", null, "Something went wrong"),
        });
      }
      setIsLoading(false);
    };
    requestSSO();
  }, []);

  useEffect(() => {
    // 2) Auto submit the form, which will load its response into the iframe on the page
    try {
      formRef.current?.submit();
    } catch (error) {
      sendNotification({
        type: "negative",
        text: l10n.getString("error-unknown", null, "Something went wrong"),
      });
    }
  }, [ssoResponse])
  return (
    <LoadingSkeleton isLoading={isLoading}>
      {ssoResponse && (
        <form
          hidden
          ref={formRef}
          action={ssoResponse.action_url}
          method="POST"
          target="cardhub-integrated-app">
          <input name="redirectUrl" value={redirectUrl(ssoResponse)} />
          <input name="sso" value={ssoResponse.sso_payload} />
          <input name="isLinkedApp" value="false" />
          <button type="submit" value="Submit">Submit</button>
        </form>
      )}
      <iframe
        id="cardhub-integrated-app"
        name="cardhub-integrated-app"
        height="820px"
        width="100%"
        className={styles.container}
      />
    </LoadingSkeleton>
  )
}

export default CardHubSSO;